"use client"

import Link from "next/link"

import { useExt } from "@/hooks/use-ext"

export default function EarnMoneyButton() {
  const isReady = useExt()
  const handleOpenAside = () => {
    window.postMessage({ action: "open-extension-sidepanel" }, "*")
  }
  return isReady ? (
    <div
      onClick={handleOpenAside}
      className="cursor-pointer text-sm text-[#C9CDD4]"
    >
      Snap to Earn Money
    </div>
  ) : (
    <div className="text-sm text-[#C9CDD4]">
      <Link href="/how-to-use">Snap to Earn Money</Link>
    </div>
  )
}
